import { IMockSelfTable } from 'mocks/types/mockDbTables';
import { faker } from '@faker-js/faker';
import { genPhone } from 'mocks/utils/mockCommon';

export const generateSelf = (): IMockSelfTable => {
  return {
    id: faker.string.uuid(),
    firstName: faker.person.firstName(),
    lastName: faker.person.lastName(),
    email: faker.internet.email(),
    phone: genPhone(),
    pid: `P${faker.number.int({ min: 1000000, max: 9000000 })}`,
  };
};
